import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConnectedPage } from './../root_classes/connected-page';
import { ConstantsModule } from './../constants/constants.module';

@Component({
	selector: 'app-my-account',
	templateUrl: './my-account.component.html',
	styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent extends ConnectedPage implements OnInit {

	// Form data.
	userInfoForm = new FormGroup({
		nameControl: new FormControl(''),
		firstnameControl: new FormControl(''),
	});

	public username: string = "";
	public role: string = "U";
	public company: string = "";

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);
	}

	ngOnInit(): void {
		// Chargement des paramètres de l'utilisateur.
		this.put("/api/user-info", undefined,
			(data) => {
				this.username = data.RES.local.username;
				this.role = data.RES.role;
				this.company = data.RES.company == undefined ? "" : data.RES.company.name;
				this.userInfoForm.controls["nameControl"].setValue(data.RES.name);
				this.userInfoForm.controls["firstnameControl"].setValue(data.RES.firstname);
			},
			(err) => {
				this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			}
		);
	}

	public doSave(): void {
		// Sending data.
		var newData = {
			name: this.userInfoForm.controls["nameControl"].value,
			firstname: this.userInfoForm.controls["firstnameControl"].value
		}
		this.put("/api/user-info-update", newData,
			(response:any) => {
				if (response.DATA == "OK") {
					this.alertLine.alertSuccessMessage = "Données mises à jour.";
					return;
				}

				this.alertLine.alertDangerMessage = "Impossible de mettre à jour vos données. Merci de contacter votre administrateur.";
				return;
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de mettre à jour vos données. Merci de contacter votre administrateur.";
				return;
			}
		);
	}
}
